import { ChangeEventHandler, memo } from "react";
import { Input } from "../ui/input";

export const FilterYear = memo(({ query, onChange, placeHolder = "" }: { query: string; onChange: ChangeEventHandler<HTMLInputElement>; placeHolder?: string }) => {
	return <Input type='number' placeholder={placeHolder} value={query} onChange={onChange} className='w-28' min='2000' max='2030' />;
});
